<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('andamandaStaff.header') }}
        </div>

        <andamanda-staff-list-view
            class="andamandaStaffListView"
            :staffs="stafflist"
            :pagination="pagination"/>

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotalVisible"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>
import AndamandaStaffListView from '@/views/AndamandaStaffListView'
import { mapState } from 'vuex'

export default {
    name: 'AndamandaStaffListPage',

    components: {
        AndamandaStaffListView
    },

    computed: {
        ...mapState('andamandaStaffListPage', ['stafflist', 'totalPage'])
    },

    data () {
        return {
            staffs: [],
            pagination: {
                page: 1,
                pageTotal: 0,
                pageTotalVisible: 0,
                itemsPerPage: 50,
                dateRange: [],
                search: '',
                status: 'active'
            }
        }
    },

    mounted () {
        this.getAndamandaStaffList()
    },

    methods: {
        getAndamandaStaffList () {
            this.$store.dispatch('andamandaStaffListPage/fetchStafflist')
                .then((e) => {
                    this.pagination.pageTotal = e
                    this.pagination.pageTotalVisible = e
                    console.log('this.pagination.pageTotal' + e)
                })
        },

        onPaginationChanged (e) {
            this.pagination.page = e
            this.$store.commit('andamandaStaffListPage/setPage', e - 1)
            this.$store.dispatch('andamandaStaffListPage/fetchStafflist')
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
